import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import WSButton from "../../Components/Button/WSButton";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import AddIcon from '@mui/icons-material/Add';
import { updateMainHeader } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";

export const BankAccountList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState<string | number>(0);
    const [isPopupOpen, setPopupOpen] = useState(false);

    const dispatch = useDispatch();
    const { showMessage } = useSnackbar();

    const filters = ['All Records'];
    const [selectedFilter, setSelectedFilter] = useState(filters[0]);

    const source = {
        url: "Vyapar/BankAccount/search",
        page: 1,
        pageSize: 10,
        filter: [],
        sort: [],
    };

    useEffect(() => {
        updateMainHeader('BankAccount');
    })

    breadCrumbsStore.updateBreadCrumbs([
        { 'BankAccount List': '/Bank-account/list' },
    ]);

    const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "Vyapar/BankAccount/search",
            page: 1,
            pageSize: 10,
            filter: [
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
        switch (value) {
            case 'In Stock':
                soureFilter.filter = [{
                    "field": "name",
                    "operator": "eq",
                    "value": "In Stock"
                }]
                break

        }

    }

    const handleAction = (action: string, row: { customerName: string, id: number }) => {
        console.log("Row data:", row);

        if (action === "Edit") {
            navigate(`/Bank-account/edit/${row.id}`);
        } else if (action === "Delete") {
            setSelectedId(row.id);
            setPopupOpen(true);
        }
    };

    const columns: IColumns[] = [
        {
            header: "Account Name",
            fieldName: "accountDisplayName",
            tooltip: true,
        },
        {
            header: "Bank Name",
            fieldName: "bankName",
            tooltip: true,
        },
        {
            header: "Account Number",
            fieldName: "accountNumber",
            tooltip: true,
        },
        {
            header: "IFSC Code",
            fieldName: "ifscCode",
            tooltip: true,
        },
        {
            header: "Opening Balance",
            fieldName: "openingBalance",
            tooltip: true,
        },
        {
            header: "As Of Date",
            fieldName: "asOfDate",
            tooltip: true,
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit", "Delete"],
            actionCallback: handleAction,
        },
    ];

    const handleClick = () => {
        navigate("/Bank-account/create");
    };

    return (
        <Grid p={3}>
            <Grid container spacing={2}>
                 
                <Grid item xs={12}>
                    <WSDataGrid
                        id="bankAccountGrid"
                        title="Bank Account"
                        columns={columns}
                        source={source}
                        searchBox={{ fieldName: 'name' }}
                        addButton={{ label: "Add BankAccount", color: "secondary" }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{
                            backgroundColor: "whitesmoke",
                            border: "1px solid whitesmoke",
                        }}
                    />
                </Grid>

                <ConfirmationPopup
                    type="DELETE"
                    apiUrl="Vyapar/BankAccount"
                    id={selectedId}
                    confirmMessage="Are you sure you want to delete this bank accont?"
                    open={isPopupOpen}
                    onClose={() => setPopupOpen(false)}
                    onConfirm={(data: any) => {
                        console.log("Delete response:", data);
                        dispatch(resetDataComponent("bankAccountGrid"));
                        if (data.success === true) {
                            showMessage(data?.message, "success");
                        } else {
                            showMessage(data?.message, "error");
                        }
                    }}
                />

            </Grid>
        </Grid>
    );
});
